// framework/common/schemas/collections/calendarEvents.js
import { z } from "zod";

const ReminderSchema = z.object({
    unit: z.enum(["minutes", "hours", "days"]),
    value: z.number().int().positive(),
});

const CalendarEventSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    contextId: z.string().describe("The context this event belongs to (e.g., studentId, projectId)."),
    
    title: z.string().min(1, "Event title is required."),
    description: z.string().optional().nullable(),
    
    start: z.coerce.date().describe("The start date and time of the event."),
    end: z.coerce.date().describe("The end date and time of the event."),
    allDay: z.boolean().default(false),
    
    status: z.enum(["scheduled", "in-progress", "completed", "missed", "cancelled"]).default("scheduled"),
    reminders: z.array(ReminderSchema).optional().describe("Array of reminders to be sent before the event."),
    
    eventType: z.string().optional().nullable().describe("Category of the event for filtering/coloring (e.g., 'class', 'assessment', 'personal')."),
    relatedEntityId: z.string().optional().nullable().describe("Link to another entity, like a courseId or assessmentScheduleId."),
    
    extendedProps: z.record(z.any()).optional(),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default CalendarEventSchema;